import { useMemo } from 'react';

import {
  defaultAttachmentEditorOption,
  defaultEditorOption,
  EditorOptionMap,
} from '@/components/Editor/PlainEditor/const';
import { EditorOptionType, ToolbarOption } from '@/components/Editor/PlainEditor/types';

import { EDITOR_AI_OPTION_MAP, TOOLBAR_ADD_AI_CONTENT, TOOLBAR_AI_DISCLAIMER } from '../consts';
import { AIBaseEditorProps } from '../types';

export default function useAIEditorProps(props: AIBaseEditorProps) {
  const {
    editorOptions: editorOptionsProps,
    editorOptionMap: editorOptionMapProps,
    disabled,
    onChangeMedias,
  } = props;

  const editorOptionMap = useMemo(() => {
    if (editorOptionMapProps) {
      return editorOptionMapProps;
    }

    return new Map<string, EditorOptionType>([...EditorOptionMap, ...EDITOR_AI_OPTION_MAP]);
  }, [editorOptionMapProps]);

  const editorOptions = useMemo(() => {
    if (editorOptionsProps) {
      return editorOptionsProps;
    }

    return [
      ...(disabled ? [] : [TOOLBAR_ADD_AI_CONTENT, ToolbarOption.Separator]),
      ...(!!onChangeMedias ? defaultAttachmentEditorOption : defaultEditorOption),
      ToolbarOption.Spacer,
      TOOLBAR_AI_DISCLAIMER,
    ];
  }, [disabled, editorOptionsProps, onChangeMedias]);

  return {
    editorOptionMap,
    editorOptions,
  };
}
